/**
 * AES-256-GCM encryption keys for decrypting feconfigs API responses.
 * Injected at build time from GitHub Secrets (see scripts/ci-cd/inject-config-encryption-keys.js).
 */
export const CONFIG_ENCRYPTION_KEYS = {
    dev: 'ad1c019a21690f981a7cee42583791e0493a7c71b5d8584ba5a5bffed94d9386',
    qa: '4de178c5c8e947ef6639daecb26a7655a087c311d3ef3ee6416e5072b3a3bd13',
    uat: '0ea6db1a2f6679534c56baa41f09420cf0cdd8547d1eb2abb81540f6d1592a14',
    prod: '1849f27b5c53eac302642704ce021771b9d6ce78b27be65e262b965092f4bbdb',
};
//# sourceMappingURL=config-encryption-keys.js.map